export {
  GO_LINK_SLUG_RE,
  buildGoLinkClickData,
  extractGoLinkDataFromAnchor,
  extractGoLinkSlugs,
  openLink,
  openTrackedGoLink,
  resolveGoLinkClickAction,
  url_data,
  type GoLinkClickAction,
} from './goLinks';
